import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

const originalPush: any = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: any) {
  return originalPush.call(this, location).catch((err: any) => err);
};

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/CanNotAccess",
    name: "CanNotAccess",
    component: () => import("@/views/CanNotAccess.vue"),
    meta: { title: "PEAK Asset" },
  },
  {
    path: "/CanNotAccessMerchant",
    name: "canNotAccessMerchant",
    component: () => import("@/views/CanNotAccessMerchant.vue"),
    meta: { title: "PEAK Asset" },
  },
  {
    path: "/SessionExpire",
    name: "sessionExpire",
    component: () => import("@/views/SessionExpire.vue"),
    meta: { title: "PEAK Asset" },
  },
  { path: "*", redirect: "/404", meta: { title: "PEAK  Asset" } },
  {
    path: "/404",
    name: "pageNotFound",
    component: () => import("@/views/PageNotFound.vue"),
    meta: { title: "PEAK Asset" },
  },
  {
    path: "/",
    name: "login",
    component: () => import("@/views/login/LoginPage.vue"),
    meta: { title: "PEAK Asset" },
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("@/views/login/LogOut.vue"),
    meta: { title: "PEAK Asset" },
  },
  {
    path: "/selectList",
    name: "selectList",
    component: () => import("@/views/selectCompany/SelectList.vue"),
    meta: { title: "select_list" },
  },
  {
    path: "/home",
    name: "home",
    component: () => import("@/views/home/Home.vue"),
    meta: { title: "Menu_Home", breadcrumb: [{ name: "Menu_Home" }] },
  },
  {
    path: "/purchaseAssets",
    name: "purchaseAssets",
    component: () => import("@/views/purchaseAssets/PurchaseAssets.vue"),
    meta: { title: "purchaseAssets", breadcrumb: [{ name: "purchaseAssets" }] },
  },
  {
    path: "/saleAssets",
    name: "saleAssets",
    component: () => import("@/views/saleAssets/SaleAssets.vue"),
    meta: { title: "saleAssets", breadcrumb: [{ name: "saleAssets" }] },
  },
  {
    path: "/assetUnit",
    name: "assetUnit",
    component: () => import("@/views/assets/AssetUnit.vue"),
    meta: { title: "Unit_Asset", breadcrumb: [{ name: "Unit_Asset" }] },
  },
  {
    path: "/assetTemplate",
    name: "assetTemplate",
    component: () => import("@/views/assets/AssetTemplate.vue"),
    meta: { title: "Asset_Register", breadcrumb: [{ name: "Asset_Register" }] },
    children: [
      {
        path: "assetTemplateDetail",
        name: "assetTemplateDetail",
        component: () => import("@/views/assets/assetTemplateDetail/AssetTemplateDetail.vue"),
        meta: {
          title: "assetTemplateDetail",
          breadcrumb: [{ name: "Asset", linkName: "assetTemplate" }],
        },
      },
      {
        path: "assetDetail",
        name: "assetDetail",
        component: () => import("@/views/assets/assetDetail/AssetDetail.vue"),
        meta: {
          breadcrumb: [{ name: "Asset", linkName: "assetTemplate" }],
        },
      },
      {
        path: "importAssetTemplate",
        name: "importAssetTemplate",
        component: () => import("@/views/assets/importAssetTemplate/ImportAssetTemplate.vue"),
        meta: {
          breadcrumb: [{ name: "Asset", linkName: "assetTemplate" }, { name: "Import_Asset_Group" }],
        },
      },
      {
        path: "importAssetCarryBalance",
        name: "importAssetCarryBalance",
        component: () => import("@/views/assets/importAssetCarryBalance/ImportAssetCarryBalance.vue"),
        meta: {
          breadcrumb: [{ name: "Asset", linkName: "assetTemplate" }, { name: "Import_Record_Asset_Balance" }],
        },
      },
    ],
  },
  {
    path: "/keeper",
    name: "keeper",
    component: () => import("@/views/keeper/Keeper.vue"),
    meta: { title: "keeper", breadcrumb: [{ name: "keeper" }] },
  },
  //keeper
  {
    path: "/setting",
    name: "setting",
    component: () => import("@/views/setting/Setting.vue"),
    meta: { title: "Setting", breadcrumb: [{ name: "Setting" }] },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
